import React from 'react'
import { useLocation } from 'react-router-dom'

import { routes } from 'constants/routes'

import Navbar from 'components/Navbar'
import Link from 'components/Link'
import { ConnectedUserDropdown } from 'modules/user/components/UserNavbarSection/UserDropdown'

import {
  Header,
  LogoWrapper,
  Text,
  HeaderLinkButton,
} from './IndexLayout.styles'

const headerLinkProps = {
  'sign-up': {
    link: routes.SIGN_UP.create({}),
    text: 'New to Sketch?',
    buttonCopy: 'Create an Account',
  },
  'sign-in': {
    link: routes.SIGN_IN.create({}),
    text: 'Already have an account?',
    buttonCopy: 'Sign In',
  },
  'workspace-settings': {
    link: routes.WORKSPACE_AGNOSTIC_SETTINGS_GENERAL.create({}),
    text: null,
    buttonCopy: 'Back to Workspace',
  },
} as const

type HeaderLinkType =
  | 'sign-in'
  | 'sign-up'
  | 'user-profile'
  | 'workspace-settings'

interface HeaderLinkProps {
  headerLink: HeaderLinkType
}

const HeaderLink: React.FC<HeaderLinkProps> = ({ headerLink }) => {
  const { state } = useLocation()

  if (headerLink === 'user-profile') {
    return <ConnectedUserDropdown />
  }

  return (
    <>
      {headerLinkProps[headerLink].text && (
        <Text>{headerLinkProps[headerLink].text}</Text>
      )}
      <HeaderLinkButton
        tiny
        to={{
          pathname: headerLinkProps[headerLink].link,
          state,
        }}>
        {headerLinkProps[headerLink].buttonCopy}
      </HeaderLinkButton>
    </>
  )
}

export interface IndexLayoutHeaderProps {
  headerLink?: HeaderLinkType | 'none'
  blockLogoLink?: boolean
}

export const IndexLayoutHeader: React.FC<IndexLayoutHeaderProps> = ({
  headerLink,
  blockLogoLink,
}) => (
  <Header hasLink={headerLink !== 'none'}>
    <LogoWrapper>
      {blockLogoLink ? (
        <Navbar.Logo variant="black" />
      ) : (
        <Link to={routes.ENTRY.create({})}>
          <Navbar.Logo variant="black" />
        </Link>
      )}
    </LogoWrapper>
    {headerLink && headerLink !== 'none' && (
      <Navbar.Section align="end">
        <HeaderLink headerLink={headerLink} />
      </Navbar.Section>
    )}
  </Header>
)
